import { useEffect, useState } from 'react';

import { status } from '@/helpers/ApiHelper';
import type { StatusResponse } from '@/types/status';

const POLL_INTERVAL_MS = 10_000;

/**
 * Polls GET /api/status/ every 10 seconds. Returns the latest response
 * (or undefined before first response). Errors are silently swallowed so
 * the sidebar never crashes the app — we keep the last known good value.
 *
 * Sherlock doesn't ship TanStack Query yet — for a single 10s poll, plain
 * setInterval is enough.
 */
export function useStatusPoll(): StatusResponse | undefined {
  const [data, setData] = useState<StatusResponse | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;

    async function fetchOnce(): Promise<void> {
      try {
        const res = await status.get();
        if (!cancelled) setData(res);
      } catch {
        /* silent — keep last known good value */
      }
    }

    void fetchOnce();
    const id = window.setInterval(fetchOnce, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  return data;
}
